import React from "react";
import {
  SquareIcon,
  TextIcon,
  Heading1Icon,
  Heading2Icon,
  Heading3Icon,
  Heading4Icon,
  Heading5Icon,
  Heading6Icon,
  PilcrowIcon,
  LinkIcon,
  QuoteIcon,
  CodeIcon,
  ListIcon,
  ListOrderedIcon,
  MinusIcon,
  TableIcon,
  ImageIcon,
  VideoIcon,
  MusicIcon,
  FileIcon,
  PanelTopIcon,
} from "lucide-react";

const htmlTagToIconMapper = {
  section: PanelTopIcon,
  div: SquareIcon,
  span: TextIcon,
  h1: Heading1Icon,
  h2: Heading2Icon,
  h3: Heading3Icon,
  h4: Heading4Icon,
  h5: Heading5Icon,
  h6: Heading6Icon,
  p: PilcrowIcon,
  a: LinkIcon,
  blockquote: QuoteIcon,
  pre: CodeIcon,
  code: CodeIcon,
  li: ListIcon,
  ul: ListIcon,
  ol: ListOrderedIcon,
  hr: MinusIcon,
  table: TableIcon,
  thead: TableIcon,
  tbody: TableIcon,
  tr: TableIcon,
  th: TableIcon,
  td: TableIcon,
  img: ImageIcon,
  video: VideoIcon,
  audio: MusicIcon,
  iframe: FileIcon,
  svg: ImageIcon,
  //...add more icons
};

function IconFromElementType({
  elementType,
}: {
  elementType: string;
}): JSX.Element {
  if (htmlTagToIconMapper[elementType]) {
    const Icon = htmlTagToIconMapper[elementType];
    return (
      <Icon className="h-5 w-5 bg-secondary rounded-sm text-icons-secondary p-1" />
    );
  }
  // fallback icon
  return (
    <SquareIcon className="h-5 w-5 bg-secondary rounded-sm text-icons-secondary p-1" />
  );
}

export default React.memo(IconFromElementType);
